export default "__VITE_ASSET__If4ndvhU__"